module.exports = __webpack_public_path__ + "static/media/bold.9c77b5d5.svg";